export default "__VITE_ASSET__50b8bba0__"